





































import { Component, Vue, Prop, Watch, PropSync } from "vue-property-decorator";

import { singleOrDoubleRowClick } from "@/utils/dblclickrow";
@Component
export default class TableSelectSingle extends Vue {
  @Prop({ default: () => [] }) datos!: any[];
  @Prop({ default: "Seleccionar fila" }) titulo!: string;
  @Prop({ default: 400 }) height!: number;
  @Prop({ default: null }) headers!: any[] | null;
  public search: string = "";
  public selected: any[] = [];
  @PropSync("dialog", { default: false }) Xdialog!: boolean;
  // Headers por defecto
  public defaultHeaders = [];

  get computedHeaders() {
    return Array.isArray(this.headers) && this.headers.length > 0
      ? this.headers
      : this.defaultHeaders;
  }

  @Watch("selected")
  onSelectedChanged() {
    this.$emit("input", this.selected[0] || null);
  }

  public onRowDblClick(item: any) {
    //this.selected = [item];
    this.$emit("input", item || null);
    this.closeDialog();
  }

  public seleccion(e: any) {
    if (e.value) {
      this.selected = [e.item];
    } else {
      this.selected = [];
    }
  }

  public closeDialog() {
    this.Xdialog = false;
  }
  public dblclick(item: any, singleClickFunc: any, doubleClickFunc: any) {
    singleOrDoubleRowClick(item, singleClickFunc, doubleClickFunc);
  }
}
